import { render, staticRenderFns } from "./supportBankDc.vue?vue&type=template&id=6c200ddc&scoped=true"
import script from "./supportBankDc.vue?vue&type=script&lang=js"
export * from "./supportBankDc.vue?vue&type=script&lang=js"
import style0 from "./supportBankDc.vue?vue&type=style&index=0&id=6c200ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c200ddc",
  null
  
)

export default component.exports